import LoginPageConfig from './auth/login/LoginPageConfig';
import ForgotPasswordPageConfig from './auth/forgot-password/ForgotPasswordPageConfig';
import {
  FAQPageConfig,
  FAQEditPageConfig,
  FAQThematicEditPageConfig,
  FAQCategoryEditPageConfig
} from './FAQ/FAQPageConfig';
import Error403PageConfig from './errors/403/Error403PageConfig';
import Error404PageConfig from './errors/404/Error404PageConfig';
import Error500PageConfig from './errors/500/Error500PageConfig';
import {
  ProfileConfig,
  ManagersConfig,
  CustomRequestConfig
} from './profile/profileConfig';
import { LoyaltyConfig } from './loyalty_campaign/loyaltyConfig';
import {
  HairdresserEditMinisiteConfig,
  HairdresserEditConfig,
  HairdresserAddConfig,
  HairdresserListConfig,
  HairdresserImportHourConfig,
  HairdresserAssociationListConfig,
  HairdresserStatsConfig,
  HairdresserDashboardMinisiteConfig,
  HairdresserTagsConfig,
  HairdresserMessagesConfig,
  MassAdminPicturesConfig,
  MassAdminBusinessHoursConfig
} from './hairdresser/HairdresserConfig';
import {
  LegalsEditConfig,
  LegalsManagerConfig,
  LegalsAddConfig,
  LegalsListConfig
} from './legals/LegalsConfigs';
import {
  NationalOperationsConfig,
  NationalOperationsManagerConfig,
  NationalOperationAddConfig,
  NationalOperationEditConfig
} from './national_operations/NationalOperationsConfig';
import MinisiteConfig from './minisite/MinisiteConfig';
import {
  MinisiteMessageListConfig,
  MinisiteMessageAddConfig,
  MinisiteMessageEditConfig
} from './minisite_message/MinisiteMessageConfig';
import {
  MinisiteTagListConfig,
  MinisiteTagAddConfig,
  MinisiteTagEditConfig
} from './minisite_tag/MinisiteTagConfig';
import NationalPricesConfig from './national_prices/NationalPricesConfig';
import { JobEditConfig, JobAddConfig, JobConfigList } from './job/JobConfig';
import {
  ContactsListConfig,
  OriginsListConfig,
  OriginsEditConfig,
  OriginsAddConfig
} from './contacts/ContactsConfig';
import {
  ServicesConfig,
  ServicesManagerConfig,
  ServiceEditConfig,
  ServiceAddConfig
} from './services/ServicesConfig';
import {
  FeedbacksListConfig,
  FeedbacksReceiverConfig
} from './feedbacks/FeedbacksConfig';
import {
  CollaboratorsListConfig,
  CollaboratorAddConfig,
  CollaboratorEditConfig,
  UsersListConfig,
  GroupsListConfig,
  GroupsAddConfig,
  GroupsEditConfig,
  UsersAddConfig,
  UsersEditConfig
} from './users_groups/UsersGroupsConfig';
import {
  DashboardConfig,
  DashboardSlidesConfig,
  DashboardSlidesAddConfig,
  DashboardSlidesEditConfig,
  DashboardNewsConfig,
  DashboardNewsAddConfig,
  DashboardNewsEditConfig,
  DashboardNotificationsConfig,
  DashboardNotificationsAddConfig,
  DashboardNotificationsEditConfig
} from './dashboard/DashboardConfig';
import { PressAdminConfig, PressListConfig } from './press/pressConfig';
import DocumentationConfig from './documentation/documentationConfig';
import {
  TermsPage,
  TermsPageLogin,
  PrivacyPolicy,
  PrivacyPolicyLogin,
  CookiesPolicy,
  CookiesPolicyLogin
} from './auth/terms/TermsConfig';
import { CodesConfig } from "./codes/codesConfig"
import MassAdminConfig from './massAdmin/MassAdminConfig';

const pagesConfigs = [
  LoyaltyConfig,
  ProfileConfig,
  ManagersConfig,
  CustomRequestConfig,
  LoginPageConfig,
  ForgotPasswordPageConfig,
  Error403PageConfig,
  Error404PageConfig,
  Error500PageConfig,
  MassAdminConfig,
  MinisiteConfig,
  HairdresserEditMinisiteConfig,
  HairdresserDashboardMinisiteConfig,
  HairdresserStatsConfig,
  HairdresserAddConfig,
  HairdresserEditConfig,
  HairdresserListConfig,
  HairdresserImportHourConfig,
  HairdresserAssociationListConfig,
  HairdresserTagsConfig,
  HairdresserMessagesConfig,
  MassAdminPicturesConfig,
  MassAdminBusinessHoursConfig,
  LegalsManagerConfig,
  LegalsListConfig,
  LegalsAddConfig,
  LegalsEditConfig,
  NationalOperationsConfig,
  NationalOperationsManagerConfig,
  NationalOperationAddConfig,
  NationalOperationEditConfig,
  NationalPricesConfig,
  MinisiteMessageListConfig,
  MinisiteMessageAddConfig,
  MinisiteMessageEditConfig,
  MinisiteTagListConfig,
  MinisiteTagAddConfig,
  MinisiteTagEditConfig,
  JobConfigList,
  JobAddConfig,
  JobEditConfig,
  FAQPageConfig,
  FAQEditPageConfig,
  FAQThematicEditPageConfig,
  FAQCategoryEditPageConfig,
  FeedbacksListConfig,
  FeedbacksReceiverConfig,
  ContactsListConfig,
  OriginsListConfig,
  OriginsAddConfig,
  OriginsEditConfig,
  ServicesManagerConfig,
  ServicesConfig,
  ServiceAddConfig,
  ServiceEditConfig,
  CollaboratorsListConfig,
  CollaboratorAddConfig,
  CollaboratorEditConfig,
  UsersListConfig,
  UsersAddConfig,
  UsersEditConfig,
  GroupsListConfig,
  GroupsAddConfig,
  GroupsEditConfig,
  DashboardConfig,
  DashboardSlidesConfig,
  DashboardSlidesAddConfig,
  DashboardSlidesEditConfig,
  DashboardNewsConfig,
  DashboardNewsAddConfig,
  DashboardNewsEditConfig,
  DashboardNotificationsConfig,
  DashboardNotificationsAddConfig,
  DashboardNotificationsEditConfig,
  DocumentationConfig,
  // PressAdminConfig,
  // PressListConfig,
  TermsPage,
  TermsPageLogin,
  PrivacyPolicy,
  PrivacyPolicyLogin,
  CookiesPolicy,
  CookiesPolicyLogin,
  CodesConfig
];

export default pagesConfigs;
